/**
 * 单据管理-历史记录
 * Author:  Fjj
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/8/12      1.0     First version  BY GSM
 * 2022/9/13      2.0     Second version 优化处理 BY FJJ
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import { Spin} from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import {toFixed2} from '@utils/utils';
import {getInfo,getTotal} from "./Info";
import HistoryTop from "./HistoryTop";
import "../Bill.less";

export default class History extends React.Component{
    static defaultProps = {
        renderPanel: true,
        type: '1',// 正常页 由于接口返回结构不一致，增类型判断显示orderInfo ： 默认类型 1显示  model.orderInfo ,类型2显示model
    }
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            orderInfo: {},

            loading: false,
        }
    }
    /**
     * 获取名称
     * @param orderType
     * @return {string}
     */
    getName(orderType){
        let name = '';
        switch (orderType) {
            case 'load':
                name = Lang({id: 'ZhuangXiangDan', default: '装箱单'});
                break;
        }
        return name;
    }
    /**
     * 设置 信息头
     * */
    setOrderInfo(res){
        if(this.props.fetchCallBack)this.props.fetchCallBack(res); // 回调到管理页
        if(this.props.type=='2'){
            if(res&&res.model) this.setState({
                orderInfo:res.model
            })
        }else if(res&&res.model&&res.model.orderInfo)this.setState({
            orderInfo:res.model.orderInfo
        })

    }
    topCallback(){
        if(this.props.callBack)this.props.callBack()
    }
    render(){
        const {loading, orderType,id,columns,fetchApi,callBackFields,scroll,title,showRecover,recoverUrl } = this.props;
        const {orderInfo,} = this.state;
        return (<Spin spinning={loading}>
                        <HistoryTop title={title}
                                    recoveryHistoryBack={()=>this.topCallback()}
                                    callBack={()=>this.topCallback()}
                                    orderInfo={orderInfo}
                                    recoverUrl={recoverUrl}
                                    showRecover={showRecover} />
                        {getInfo(orderType,orderInfo)}
                        <AutoFetchTable tableLayout={'fixed'}
                                        columns={columns}
                                        bordered={true}
                                        rowClassName={(record, index)=>{return record.isSign?"is-sign-bg":""}}
                                        callBackFields = {callBackFields}
                                        paginationFlag={false}
                                        scroll={scroll||(orderType=='load'?{x:4500, y:450}:{y: 450})}
                                        fetchCallBack={(res)=>this.setOrderInfo(res)}
                                        precondition={{id: id}}
                                        summary={(orderType=='trucking'||orderType=='trucking_sub')?getTotal:null}
                                        fetchApi={fetchApi} />

                    </Spin>)
    }
}
